/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { MouseEventHandler } from 'react';
import { Button } from 'sarsaparilla';
import { formatPrice } from '../../utils/index';
import type { Reservation } from '../../../types/permit';

interface CTABarTypes {
    onSubmitHandler: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
    reservations: Array<Reservation>;
    total: number;
    onShowSummaryModal: () => void;
    isSubmitting: boolean;
}

export default function CTABar({
    onSubmitHandler,
    onShowSummaryModal,
    reservations,
    isSubmitting,
    total,
}: CTABarTypes) {
    const hasReservations = !!reservations.length;

    if (!hasReservations) {
        return null;
    }

    const reservationFee = reservations
        .map((item) => item?.permit?.fees ?? 0)
        .reduce((a, b) => a + b, 0);
    const totalValue = total + reservationFee;

    return (
        <div className="tp-cta-bar">
            <div className="tp-cta-bar-total">
                <div className="tp-cta-bar-total-title">Total</div>
                <div className="tp-cta-bar-total-description">
                    {formatPrice(totalValue)}
                </div>
            </div>
            <Button
                className="tp-cta-bar-summary-button"
                onClick={onShowSummaryModal}
                appearance="link"
                isLoading={isSubmitting}
            >
                Show Summary
            </Button>
            <Button
                className="tp-cta-bar-proceed-button"
                onClick={onSubmitHandler}
                isDisabled={isSubmitting}
            >
                Proceed to Cart
            </Button>
        </div>
    );
}
